module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-stefania-626418bcf2cd1e71d3e4a73f113f0f8c.jpg";